"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.Caption = exports.Body = exports.bodyStyle = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var getFontSize = function (size) {
    switch (size) {
        case 'xxl':
            return '22px';
        case 'xl':
            return '18px';
        case 'lg':
            return '16px';
        case 'md':
            return '14px';
        case 'sm':
        default:
            return '12px';
    }
};
var bodyStyle = function (props) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  font-family: ", ";\n  color: ", ";\n  margin: 0;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  font-size: ", ";\n  font-family: ", ";\n  color: ", ";\n  margin: 0;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), getFontSize(props.size || 'md'), function (p) {
    return props.bold ? p.theme.paragraphs.fontFamily.bodyBold : p.theme.paragraphs.fontFamily.bodyRegular;
}, function (p) { return p.theme.paragraphs.color; }); };
exports.bodyStyle = bodyStyle;
exports.Body = styled_components_1.default.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.bodyStyle);
exports.Caption = styled_components_1.default.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  text-transform: uppercase;\n  line-height: 1.3;\n"], ["\n  margin: 0;\n  color: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  text-transform: uppercase;\n  line-height: 1.3;\n"])), function (p) { return p.theme.paragraphs.color; }, function (p) { return getFontSize(p.size || 'md'); }, function (p) { return p.theme.paragraphs.fontFamily.caption; });
exports.Footer = styled_components_1.default.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0;\n  color: ", ";\n  font-size: 12px;\n  font-family: ", ";\n  line-height: 1.3;\n"], ["\n  margin: 0;\n  color: ", ";\n  font-size: 12px;\n  font-family: ", ";\n  line-height: 1.3;\n"])), function (p) { return p.theme.paragraphs.color; }, function (p) { return p.theme.paragraphs.fontFamily.footer; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
